export function replaceTrToEn(text): string {
  if (!text) {
    return null;
  }

  text = text.trim();

  return text
    ? text.toLocaleLowerCase('tr').replace(/ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/ş/g, 's')
      .replace(/ı/g, 'i')
      .replace(/ö/g, 'o')
      .replace(/ç/g, 'c')
      .replace(/ /g, '.')
    : text;
}

export function generateUsername(name: string, surname: string): string {
  return name && surname
    ? `${name}.${surname}`
    : (name
      ? `${name}`
      : (surname ? `${surname}` : ''))
}
